import { render } from "./TelebotModal.vue?vue&type=template&id=fdb5dccc&scoped=true"
import script from "./TelebotModal.vue?vue&type=script&lang=js"
export * from "./TelebotModal.vue?vue&type=script&lang=js"

import "./TelebotModal.vue?vue&type=style&index=0&id=fdb5dccc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb5dccc"]])

export default __exports__